import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initSentry } from './lib/sentry.ts'

// Initialize error tracking before rendering
initSentry();

const isProyectMindAppCache = (name: string) => {
  const lower = name.toLowerCase();
  return (
    lower.includes('proyectmind') ||
    lower.includes('workbox') ||
    lower.includes('vite') ||
    /(^|-)precache-v\d+-|(^|-)runtime-|(^|-)googleanalytics-/.test(lower)
  );
};

const clearStaleMobileAppState = async () => {
  const hadController = 'serviceWorker' in navigator && Boolean(navigator.serviceWorker.controller);

  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.allSettled(registrations.map((registration) => registration.unregister()));
    } catch {
      // Browser does not allow service-worker inspection in this context.
    }
  }

  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      await Promise.allSettled(
        cacheNames
          .filter(isProyectMindAppCache)
          .map((cacheName) => caches.delete(cacheName))
      );
    } catch {
      // Cache Storage may be unavailable in private or embedded mobile contexts.
    }
  }

  if (hadController) {
    try {
      const reloadFlag = 'pm-sw-cleaned-once';
      if (sessionStorage.getItem(reloadFlag) !== 'true') {
        sessionStorage.setItem(reloadFlag, 'true');
        window.location.reload();
      }
    } catch {
      window.location.reload();
    }
  }
};

void clearStaleMobileAppState();

const rootElement = document.getElementById("root")!;

// Always use createRoot — this is a pure SPA (no SSR).
// hydrateRoot is only for server-rendered HTML; using it on the
// client-side skeleton loader would trigger hydration mismatch errors.
createRoot(rootElement).render(<App />);
